import { InjectionToken } from '@angular/core';

export interface GitInfo {
  branchName: string;
  sha: string;
  shaShort: string;
}

export const GIT_INFO = new InjectionToken<GitInfo>('GIT_INFO');
